import React from 'react';
import { Section } from 'new/components/settings/VendorBuilder/components/Section';
import { FormBuilder } from 'new/components/settings/VendorBuilder/FormControlBuilder';
import { Stack } from '@mui/material';
import Typography from 'new/elements/Typography';
interface GeneralProps {}

const fields = [
  {
    type: 'text',
    label: (
      <>
        Connector Name <code>vendor.name</code>
      </>
    ),
    name: 'name',
    required: true,
    description: (
      <Stack padding="16px">
        <Typography variant="h6">
          Unique Connector Name (<code>vendor.name</code>)
        </Typography>
        <Typography variant="body2">
          Set a unique connector name for this template. This is the <code>name</code> property of
          the <code>vendor</code> object in the template spec.
          <br />
        </Typography>
        <Typography variant="body2">
          <b>Recommendation:</b> To ensure unqiue names, use a short string that is close to the API
          of the connector. Ex: <code>li_mktg_api</code> for LinkedIn Marketing API.
          <br /> Name choice has no impact other than it being the unique index.
        </Typography>
      </Stack>
    ),
  },
  {
    type: 'text',
    name: 'display_name',
    label: (
      <>
        Display Name<code>vendor.display_name</code>
      </>
    ),
    required: true,
    description: (
      <Stack padding="16px">
        <Typography variant="h6">
          Display Name(<code>vendor.display_name</code>)
        </Typography>
        <Typography variant="body2">
          Set the name to be displaying along with/below the vendor logo in the connector tile.
        </Typography>
      </Stack>
    ),
  },
  {
    type: 'text',
    name: 'description',
    label: (
      <>
        Description <code>vendor.description</code>
      </>
    ),
    description: (
      <Stack padding="16px">
        <Typography variant="h6">
          Description(<code>vendor.description</code>)
        </Typography>
        <Typography variant="body2">
          Set a brief description about this connector template. Right now we do not display this
          content on the UI, but it is nice to have for future reference.
        </Typography>
        <Typography variant="body2">
          <b>Recommendation: </b> Set a short(~100-200 character) blurb about what type of connector
          this is.
        </Typography>
      </Stack>
    ),
  },
];

export const General = (props: GeneralProps) => {
  return (
    <Section defaultExpanded title="Connector Root Properties" gap="16px">
      <Typography variant="body2">
        This section contains basic details about the vendor, namely: <code>name</code>,{' '}
        <code>display_name</code>, and <code>description</code>. This content is added to the root
        of the <code>vendor</code> object .
      </Typography>
      <FormBuilder preventCleanUp fields={fields} />
    </Section>
  );
};
